import React from 'react';
import { makeStyles, MuiThemeProvider } from '@material-ui/core';
import { lightThemeV2 } from '../../settings/themes/lightThemeV2';
import { BodyContent } from '../../components/molecules/BodyContent';
import { WideContainer } from '../../components/atoms/WideContainer';
import { DynamicDashboard } from '../Projects/components/project/Dashboard/components/dynamic/DynamicDashboard';

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      flex: 1
    }
  },
  dashboardRoot: {
    width: '100%',
    fontFamily: 'Nunito',
    '& .MuiTypography-root': {
      fontFamily: 'Nunito'
    },
    '& .MuiCardContent-root': {
      padding: 20,
      '&:last-child': {
        paddingBottom: 20
      }
    }
  }
});

export const ExecutiveDashboard = () => {
  const classes = useStyles();

  return (
    <MuiThemeProvider theme={lightThemeV2}>
      <div className={classes.root}>
        <BodyContent component={WideContainer}>
          <div className={classes.dashboardRoot}>
            <DynamicDashboard />
          </div>
        </BodyContent>
      </div>
    </MuiThemeProvider>
  );
};

export default ExecutiveDashboard;
